// 不展示在菜单上的路由地址，需自行添加

export default [
  {
    name: '首页',
    url: '/',
    is_show: 1,
    alias_name: 'index',
    id: 1
  },
  {
    name: '客户',
    is_show: 1,
    url: '/customer',
    children: [
      {
        name: '客户管理',
        url: '/customer/index',
        is_show: 1
      },
      {
        name: '客户详情',
        url: '/customer/detail/:id',
        is_show: 1
      },
      {
        name: '客户统计',
        url: '/customer/statistics',
        is_show: 1
      },
      {
        name: '标签管理',
        url: '/customer/label',
        is_show: 1
      }
    ]
  },
  {
    name: '任务编辑',
    is_show: 0,
    url: '/taskedit',
    children: [
      {
        name: '任务管理编辑',
        url: '/task/shoppingGuideTask/:task_id',
        is_show: 0,
        alias_name: 'shoppingGuideTaskEdit'
      }
    ]
  },
  {
    name: '客户转化',
    is_show: 0,
    url: '/customerConversion',
    children: [
      {
        name: '欢迎语编辑',
        url: '/customerConversion/welcomeLanguage/:id',
        is_show: 0,
        alias_name: 'welcomeLanguageEdit'
      },
      {
        name: '提成报表',
        url: '/customerConversion/commissionReport',
        is_show: 1,
        alias_name: 'commissionReport'
      },
      {
        name: '提成明细',
        url: '/customerConversion/commissionReport/:id',
        is_show: 0,
        alias_name: 'commissionDetail'
      }
    ]
  },
  {
    name: '引流获客',
    is_show: 0,
    url: '/drainage',
    children: [
      {
        name: '渠道活码编辑',
        url: '/drainage/channelCode/:id',
        is_show: 0,
        alias_name: 'channelCodeEdit'
      },
      {
        name: '公众号引流',
        url: '/drainage/officialAccount',
        is_show: 1,
        alias_name: 'officialAccount'
      }
    ]
  },
  {
    name: '客户群',
    is_show: 0,
    url: '/membership',
    children: [
      {
        name: '群sop详情',
        url: '/membership/membershipSopEdit/:id',
        is_show: 1,
        alias_name: 'membershipSopEdit'
      },
      {
        name: '群规则设置',
        url: '/membership/membershipSopAdd/:id',
        is_show: 1,
        alias_name: 'membershipSopAdd'
      },
      {
        name: '客户群发',
        url: '/membership/customerGroup',
        is_show: 1,
        alias_name: 'customerGroup'
      },
      {
        name: '客户群发编辑',
        url: '/membership/customerGroup/:id',
        is_show: 0,
        alias_name: 'customerGroupDetail'
      },
      {
        name: '客户群发详情',
        url: '/membership/customerGroupInfo/:id',
        is_show: 0,
        alias_name: 'customerGroupInfo'
      }
    ]
  },
  {
    name: '企业微信模块',
    is_show: 1,
    url: '/qwAuth',
    children: [
      {
        name: '企业微信模块-QW',
        is_show: 1,
        url: '/qwAuth',
        children: [
          {
            name: '绑定电话',
            url: '/qwAuth/bindPhone',
            is_show: 1,
            alias_name: 'marketingsalesman'
          },
          {
            name: '添加应用',
            url: '/qwAuth/createdApp',
            is_show: 1,
            alias_name: 'rolePrivileges'
          },
          {
            name: '授权客户联系',
            url: '/qwAuth/createdContacts',
            is_show: 1,
            alias_name: 'rolePrivileges'
          },
          {
            name: '添加客服',
            url: '/qwAuth/configApp',
            is_show: 1,
            alias_name: 'exportList'
          },
          {
            name: '提交配置',
            url: '/qwAuth/subConfig',
            is_show: 1,
            alias_name: 'relationBind'
          }
        ]
      }
    ]
  },
  {
    name: '群sop CP',
    is_show: 0,
    url: '/membership',
    children: [
      {
        name: '群sop详情',
        url: '/membership/membershipSopEdit',
        is_show: 1,
        alias_name: 'membershipSopEdit'
      },
      {
        name: '群规则设置',
        url: '/membership/membershipSopAdd',
        is_show: 1,
        alias_name: 'membershipSopAdd'
      }
    ]
  },
  {
    is_show: 1,
    name: '素材管理',
    url: '/sucai',
    children: [
      {
        alias_name: 'sucai',
        is_show: 1,
        name: '素材管理',
        url: '/sucai/index'
      }
    ]
  }
]
